<template>
    <v-snackbar
      v-model="getToast.status"
      color="seconary"
      top
      dense
      right
      class="subtitle-1"
    >
      {{ getToast.msg }}
    </v-snackbar>
</template>

<script>
export default {
  computed: {
    getToast(){
      return this.$store.getters.getToast
    }
  }
}
</script>
